import { Directive, ElementRef, HostListener, Input } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[date]' })
export class DateDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/\D+/g, '');
    if (trimmed.length > 8) {
      trimmed = trimmed.substr(0, 8);
    }
    const numbers = [];
    numbers.push(trimmed.substr(0, 4));
    if (trimmed.length > 4) {
      numbers.push(trimmed.substr(4, 2));
    }
    if (trimmed.length > 6) {
      numbers.push(trimmed.substr(6));
    }
    input.value = numbers.join('-');
  }
}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/directives/date/date.directive.ts